import { render, staticRenderFns } from "./ExpenService.vue?vue&type=template&id=05de7985&scoped=true"
import script from "./ExpenService.vue?vue&type=script&lang=js"
export * from "./ExpenService.vue?vue&type=script&lang=js"
import style0 from "./ExpenService.vue?vue&type=style&index=0&id=05de7985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de7985",
  null
  
)

export default component.exports